import { render, staticRenderFns } from "./collectionRegistered.vue?vue&type=template&id=7441a226&scoped=true"
import script from "./collectionRegistered.vue?vue&type=script&lang=js"
export * from "./collectionRegistered.vue?vue&type=script&lang=js"
import style0 from "./collectionRegistered.vue?vue&type=style&index=0&id=7441a226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7441a226",
  null
  
)

export default component.exports